/// <amd-module name="Build/Admin/Common/Components/ReimageDisabledWarning" />
import * as React from "react";

import { format } from "VSS/Core/Util/String";

import { Icon } from "VSSUI/Icon";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { Link } from "VSSUI/Link";

import { FwLinks } from "Build/Admin/Common/Constants";

import { OrchestrationMode, VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";
import * as Resources from "Build/Admin/Common/Resources";

export interface IReimageDisabledWarningProps {
    isVisible: boolean;
}

export class ReimageDisabledWarning extends React.PureComponent<IReimageDisabledWarningProps> {
    constructor(props: IReimageDisabledWarningProps) {
        super(props);
    }

    public render(): JSX.Element {
        return <ConditionalChildren renderChildren={this.props.isVisible}>
            <span className="bolt-formitem-message body-xs">
                <Icon iconName="Info" />
                {format(Resources.EphemeralDiskWarning)}
                <Link className="margin-left-4" href={FwLinks.EphemeralDiskInfo} target="_blank">{Resources.LearnMore}</Link>
            </span>
        </ConditionalChildren>

    }
}

export const reimageIsNotAvaialable = (vmss?: VirtualMachineScaleSet): boolean => {
    return vmss?.properties.orchestrationMode == OrchestrationMode.Flexible &&
        vmss?.properties?.virtualMachineProfile?.storageProfile?.osDisk?.diffDiskSettings?.option != "Local"
};
